import gql from "graphql-tag";

export default gql`
	type License {
		id: ID!
		dbID: ID!
		orderNumber: String!
		productTitle: String!
		licenseName: String
		serialNumbers: [String]
		type: String!
		purchaseDate: Date!
		expirationDate: Date
		isExpired: Boolean
		isAutoBillingEnabled: Boolean
		isActive: Boolean
		status: String
		isTrial: Boolean
		lastOrder: Order
	}

	type LicenseSet {
		subscriptions: [License]
		perpetuals: [License]
	}

	extend type Query {
		licenses: LicenseSet
		license(id: ID!): License
	}
`;
